import React, { useEffect } from "react";
import { IoLocationOutline } from "react-icons/io5";
import { IoIosLink } from "react-icons/io";

import { useNavigate } from "react-router-dom";
import { useLazyGetallclinicinfoQuery } from "../State/Api/AddClinicInfoApiSlice";


const ClinicProfile = () => {
  const navigate = useNavigate();
  const uniqueUserId = localStorage.getItem("userUniqueID");
  const [fetchClinic, { data: clinicData, isFetching, isError }] =
    useLazyGetallclinicinfoQuery();

  useEffect(() => {
    if (uniqueUserId) {
      fetchClinic(uniqueUserId);
    }
  }, [uniqueUserId]);

  const invite = clinicData?.inviteUser;
  const contact = clinicData?.contactDetails;
  const info = clinicData?.informationDetails;
  const compliance = clinicData?.complianceDetails;
  const subscription = clinicData?.subscriptionDetails;
  const additional = clinicData?.additionalDetails;

  const profilestyles = `
    .clinic-profile-container {
      padding: 0.1rem;
      background-color: #f7fbf8;
    }

    .profile-header {
      height:102px;
      background: linear-gradient(170deg, #BCDF4B 0%, #A3A3A3 100%);
      padding: 1rem 1.5rem;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
    }

    .clinic-info {
      display: flex;
      align-items: center;
      position:absolute;
      bottom:70px
    }

    .clinic-avatar {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      object-fit: cover;
      background-color: #fff;
      margin-right: 1rem;
      border: 1px solid #ccc;
    }

    .clinic-details h4 {
      margin: 0;
      font-size: 1.25rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .badge-pro {
      background-color: #38d39f;
      color: white;
      font-size: 0.75rem;
      padding: 0.2rem 0.5rem;
      border-radius: 4px;
    }

    .clinic-id,
    .clinic-location,
    .clinic-website {
      font-size: 0.875rem;
      color: #555;
      margin: 0;
    }

    .clinic-actions {
      display: flex;
      gap: 0.5rem;
      align-items:flex-end;
      justify-content:flex-end;
    }

    .btn-change,
    .btn-more {
      background-color: white;
      border: 1px solid #ccc;
      padding: 0.4rem 0.8rem;
      border-radius: 4px;
      cursor: pointer;
    }

    .tabs {
      margin-top: 8rem;
      border-top: 1px solid #ccc;
    }

    .active-tab {
      display: inline-block;
      padding: 0.5rem 1rem;
      border-bottom: 3px solid #4caf50;
      font-weight: bold;
      color: #333;
    }

    .info-sections {
      display: flex;
      justify-content: space-between;
      margin-top: 1.5rem;
      gap: 1rem;
      flex-wrap: wrap;
    }

    .info-card {
      background-color: white;
      flex: 1;
      border-radius: 8px;
      padding: 1rem;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
      min-width: 280px;
    }

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 0;
      border-bottom: 1px dashed #e0e0e0;
      font-size: 0.9rem;
    }

    .info-card h6 {
      font-weight: 600;
      font-size: 1rem;
      margin-bottom: 1rem;
    }

    .info-card p {
      margin: 0.5rem 0;
      font-size: 0.9rem;
    }

    .verified {
      background-color: #c3f3d7;
      color: #1e824c;
      font-size: 0.75rem;
      padding: 2px 6px;
      border-radius: 5px;
      margin-left: 0.5rem;
    }

    .not-verified {
      background-color: #fddede;
      color: #d9534f;
      font-size: 0.75rem;
      padding: 2px 6px;
      border-radius: 5px;
      margin-left: 0.5rem;
    }

    .compliance-box {
      padding: 1rem;
      margin-top: 2rem;
      border-radius: 6px;
      background-color: white;
    }

    .compliance-box h6 {
      font-weight: 600;
      font-size: 1rem;
      margin: 0;
    }
  `;

  return (
    <>
      <style>{profilestyles}</style>
      <div className="clinic-profile-container">
        {/* Header */}
        <div
          className="profile-container"
          style={{
            border: "1px solid #DEE2E6",
            position: "relative",
            borderRadius: "8px",
            backgroundColor: "white",
          }}
        >
          <div className="profile-header">
            <div className="clinic-info">
              <img
  src={
    additional?.logoUpload
      ? `${additional.logoUpload}?${Date.now()}`
      : "https://png.pngtree.com/png-clipart/20250211/original/pngtree-flat-hospital-vector-png-image_20416326.png"
  }
  alt="avatar"
  className="clinic-avatar"
/>

              <div className="clinic-details mt-5">
                <h4>
                  {invite?.clinic_Hospital_Name || "N/A"}

                  <span className="badge-pro">
                    {subscription?.subscriptionType}
                  </span>
                </h4>
                <p className="clinic-id">
                  {invite?.clinic_Hospital_ID || "N/A"}
                </p>
                <div className="mt-2" style={{ display: "flex", gap: "1rem" }}>
                  <p className="clinic-location d-flex gap-1 align-items-center">
                    <IoLocationOutline /> {info?.city}, {info?.state}
                  </p>
                  <p className="clinic-website d-flex gap-1 align-items-center">
                    <IoIosLink /> {info?.websiteURL}
                  </p>
                </div>
              </div>
            </div>
            <div className="clinic-actions">
              <button
                className="gradient-dark-button px-3"
                onClick={() => {
                  navigate("/clinic/Registration", {
                    state: { id: additional?.userUniqueID },
                  });
                }}
              >
                Edit
              </button>
              {/* <button className="btn-more">⋯</button> */}
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs ps-3">
            <span className="active-tab">Overview</span>
          </div>
        </div>

        {/* Info Panels */}
        <div className="row info-sections">
          {/* Info */}
          <div className="col-12 col-md-4 info-card shadow-sm">
            <h6>Info</h6>
            <div className="info-row">
              <span className="label">Mobile</span>
              <span className="value">
  {info?.primaryPhoneNumber
    ? info.primaryPhoneNumber.slice(-10) // ✅ takes only last 10 digits
    : ""}
  <span className="verified">Verified</span>
</span>

            </div>
            <div className="info-row">
              <span className="label">Email</span>
              <span className="value">
                {invite?.email}{" "}
                <span className="not-verified">Not Verified</span>
              </span>
            </div>
            <div className="info-row">
              <span className="label">Location</span>
              <span className="value">
                {info?.city}, {info?.country}
              </span>
            </div>
            <div className="info-row">
              <span className="label">Web Site</span>
              <span className="value">{info?.websiteURL}</span>
            </div>
            <div className="info-row">
              <span className="label">Company</span>
              <span className="value">{invite?.clinic_Hospital_Name}</span>
            </div>
          </div>

          {/* Contact Person Details */}
          <div className="col-12 col-md-4 info-card shadow-sm">
            <h6>Contact Person Details</h6>
            <div className="info-row">
              <span className="label">Contact Name</span>
              <span className="value">
                {contact?.contactName}{" "}
                <span className="verified">Verified</span>
              </span>
            </div>
            <div className="info-row">
              <span className="label">Email</span>
              <span className="value">
                {contact?.contactEmailAddress}{" "}
                <span className="not-verified">Not Verified</span>
              </span>
            </div>
            <div className="info-row">
              <span className="label">Designation</span>
              <span className="value">{contact?.contactDesignation}</span>
            </div>
            <div className="info-row">
  <span className="label">Primary Phone</span>
  <span className="value">
    {contact?.primaryContactPhoneNumber
      ? contact.primaryContactPhoneNumber.slice(-10)
      : ""}
  </span>
</div>

<div className="info-row">
  <span className="label">Secondary Phone</span>
  <span className="value">
    {contact?.secondaryContactPhoneNumber
      ? contact.secondaryContactPhoneNumber.slice(-10)
      : ""}
  </span>
</div>

          </div>

          {/* Subscription Details */}
          <div className="col-12 col-md-4 info-card shadow-sm">
            <h6>Subscription Details</h6>
            <div className="info-row">
              <span className="label">Plan</span>
              <span className="value">{subscription?.subscriptionType}</span>
            </div>
            <div className="info-row">
              <span className="label">Start Date</span>
              <span className="value">
                {new Date(subscription?.subscriptionStartDate)
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  .replace(/ /g, "-")}
              </span>
            </div>
            <div className="info-row">
              <span className="label">End Date</span>
              <span className="value">
                {new Date(subscription?.subscriptionEndDate)
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  .replace(/ /g, "-")}
                <span className="verified">Verified</span>
              </span>
            </div>
            <div className="info-row">
              <span className="label">Trial Version</span>
              <span className="value">
                {subscription?.isTrialVersion ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClinicProfile;
